<template>
    <div class="venue-warning-container">
        <div class="info-top">
            <p class="title">On no, you can't make an offer</p>
            <p class="desc">
                Unfortunately only users with an artist profile can apply to opportunities
            </p>
        </div>
        <a class="booking-link" href="/booking-manager">Go to Booking Manager</a>
    </div>
</template>
<script>
    export default {
        name: 'VenueWarning'
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .venue-warning-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 24px;

        .info-top {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 8px;

            .title {
                color: #dedede;
                @include base-font-24;
                font-weight: 600;
                line-height: 28px;
            }
            .desc {
                color: #8b8b8b;
                @include base-font-16;
                font-weight: 400;
                line-height: 24px;
            }
        }
        .booking-link {
            max-width: 188px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px 16px;
            border-radius: 120px;
            border: 1px solid #cdeb09;
            color: #cdeb09;
            @include base-font-14;
            line-height: 115%;
            letter-spacing: 0.14px;
            text-decoration: none;
            text-wrap: nowrap;
        }
    }
</style>
